import {SemanticLegendSettings, YAxisValues} from '../../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from '../SemanticLegendDefaults';
import {parseBucketsFromSemanticLegendSettings} from './parseBuckets';

export function getMutationVarsFromSettings(settings: SemanticLegendSettings) {
  const yAxisValue =
    settings.yAxisValue ?? DEFAULT_SEMANTIC_LEGEND_SETTINGS.yAxisValue;
  const isCategories = yAxisValue === YAxisValues.Config_Categories;

  const {customColors, bucketUpperBounds} =
    parseBucketsFromSemanticLegendSettings(settings);
  let settingsToUpdate = {
    metricName: settings.key || DEFAULT_SEMANTIC_LEGEND_SETTINGS.key,
    yValue: yAxisValue,
    excludedRunColor:
      settings.excludedRunColor ||
      DEFAULT_SEMANTIC_LEGEND_SETTINGS.excludedRunColor,
    categories: settings.categories,
    customColors: customColors,
  } as any;

  // We only need to parse the buckets for numeric configs and metric stats
  if (!isCategories) {
    settingsToUpdate = {
      ...settingsToUpdate,
      bucketUpperBounds: bucketUpperBounds?.map(bucket => bucket ?? 0) ?? [],
    };
  }

  return settingsToUpdate;
}
